<template>
    <div class="d-flex justify-center">
        <v-card
            :width="mobile ? '80%' : '55%'"
            max-height="78vh"
            color="white"
            elevation="3"
            class="d-flex flex-column"
        >
            <v-data-table-server
                :headers="category.headers"
                :items="category.lstCategory"
                :items-per-page="category.itemsPerPage"
                no-data-text="Nenhuma categoria encontrado"
                @click:row="openCategory"
                class="card-scroll"
                :page="category.page"
                :items-length="category.totalItems"
                @update:options="updateOptions"
            >
                <template v-slot:top>
                    <div :class="['px-5', mobile ? 'pb-3' : '']">
                        <v-row align="center" dense>
                            <v-col cols="12" md="9">
                                <v-text-field
                                    v-model="category.search"
                                    label="Pesquise aqui"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    max-width="300px"
                                    rounded
                                    class="pt-6"
                                    @keyup.enter="search()"
                                >
                                    <template v-slot:append-inner>
                                        <v-btn
                                            icon
                                            size="small"
                                            variant="text"
                                            @click="search()"
                                        >
                                            <v-icon class="pt-1">mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    @click="openNewCategory()"
                                    rounded
                                    variant="elevated"
                                >
                                    Adicionar
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider></v-divider>
                </template>
                <template #headers="{ columns }">
                    <tr class="custom-header" >
                        <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                            {{ column.title }}
                        </th>
                    </tr>
                </template>
            </v-data-table-server>
        </v-card>
    </div>
    <Category/>
</template>

<script>
import Category from '../Category.vue';
import { useDisplay } from 'vuetify'

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
    }),
    components: {
        Category
    },
    computed: {
        category: {
            get() {
                return this.$store.state.category
            },
        },
    },
    methods: {
        async openCategory(event, row) {
            this.$router.push({
                name: 'EditCategory',
                params: {
                    categoryId: row.item.categoryId
                }
            })
        },
        openNewCategory() {
            this.$router.push({ name: 'NewCategory' })
        },
        async search() {
            await this.$store.dispatch("category/search", { limit: this.category.itemsPerPage, reset: true })
        },
        async updateOptions(options) {
            this.$store.commit('category/setPage', options.page)

            await this.$store.dispatch("category/search", {
                limit: options.itemsPerPage,
                page: options.page,
                reset: true
            })
        }
    },
    async mounted() {
        await this.search()
    },
    watch: {
        '$store.state.category.shouldReload': {
            async handler(val) {
                if (val) {
                    await this.search()
                    this.$store.commit('category/setShouldReload', false)
                }
            }
        }
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>